import type { ThemeDefinition } from "./types";
import { hexToSrgb, hexToLinear } from "./palette";

export const shoal: ThemeDefinition = {
  label: "Shoal",
  className: "theme-shoal",
  bg: "#e0eaf4",
  text: "#1c3a5c",
  textMuted: `color-mix(in srgb, #1c3a5c 60%, transparent)`,
  accent: "#c86850",
  glassRgb: "224,234,244",
  border: "rgba(255,255,255,0.50)",
  borderHighlight: "rgba(255,255,255,0.50)",
  separator: `color-mix(in srgb, #1c3a5c 30%, transparent)`,
  selection: "#1c3a5c",
  selectionText: "#ffffff",
  gridColor: "#b8cce0",
  noiseOpacity: "0.03",
  gridOpacity: "0.7",
  textShadow: "0 -1px 0px rgba(255,255,255,0.4), 0 10px 0px rgba(10,20,40,0.15)",
  gpuClear: hexToSrgb("#e0eaf4"),
  gpuGridLine: hexToLinear("#b8cce0"),
  gpuGridAlpha: 0.7,
  gpuAxisX: hexToLinear("#c86850"),
  gpuAxisZ: hexToLinear("#1c3a5c"),
  axisXColor: "#c86850",
  axisZColor: "#1c3a5c",
  font: '"Space Grotesk", sans-serif',
};
